import { AxiosResponse } from "axios";
import {
  AltiusRes,
  ICreateShareData,
  IReachOutManage,
  IUpdateShareData,
  PostReachOutReq,
  PostReachOutRes,
  IDashboardShare,
  IGetSharesData,
  IComponent
} from "store/types";
import { toastify } from "utils/tyostify";

import { DealAction } from "..";
import { AsyncActions, AsyncActionsParams } from "../base";
import { parseLaravelErrors } from "utils/parse-laravel-errors";

export interface IShareActions {
  getSharesDataAction: (dealId: number) => Promise<IGetSharesData[]>;
  updateSharesAction: (data: IUpdateShareData) => Promise<void>;
  resendInviteAction: (inviteId: number) => Promise<void>;
  createShareAction: (data: ICreateShareData) => Promise<void>;
  postReachOutAction: (data: PostReachOutReq) => Promise<PostReachOutRes>;
  setReachOutManageAction: (data: IReachOutManage | null) => void;
  getDashboardSharesAction: (dealId: number, for_deal_dashboard?: boolean) => Promise<IDashboardShare[]>;
  getEmptyShareTreeAction: (dealId: number) => Promise<IComponent[]>;
}

export class ShareActions extends AsyncActions implements IShareActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  public getSharesDataAction = async (dealId: number): Promise<IGetSharesData[]> => {
    //this API return shares and invites in the same array
    try {
      const {
        data: { data: payload }
      }: AxiosResponse<AltiusRes<IGetSharesData[]>> = await this.api.get({
        url: `/api/v0.0.3/deals/${dealId}/share-data`
      });
      return payload;
    } catch (error) {
      throw error;
    }
  };

  public getDashboardSharesAction = async (dealId: number, for_deal_dashboard = true): Promise<IDashboardShare[]> => {
    try {
      const {
        data: { data: payload }
      }: AxiosResponse<AltiusRes<IDashboardShare[]>> = await this.api.get({
        url: `/api/v0.0.2/deals/${dealId}/shares`,
        params: {
          deal_id: dealId,
          for_deal_dashboard
        }
      });
      this.dispatch({ type: DealAction.GetDashboardSharesSuccess, payload });
      return payload;
    } catch (error) {
      throw error;
    }
  };

  public updateSharesAction = async (data: IUpdateShareData): Promise<void> => {
    const { dealId } = data;
    try {
      await this.api.patch({
        url: `/api/v0.0.3/deals/${dealId}/share-data`,
        data
      });
    } catch (error) {
      throw error;
    }
  };

  // public updateShareAction = async (data: IUpdateShareData): Promise<void> => {
  //   try {
  //     const { dealId, userId, roleId } = data;

  //     await this.api.patch({
  //       url: `/api/v0.0.2/deals/${dealId}/shares`,
  //       data: [
  //         {
  //           user_id: userId,
  //           role_id: roleId
  //         }
  //       ]
  //     });
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  // public deleteShareAction = async (shareId: number, data: IShareData): Promise<void> => {
  //   try {
  //     const { dealId, type, elements } = data;

  //     const elementsToSend: ShareDialogElements = {
  //       deal_id: [],
  //       section_id: [],
  //       form_id: [],
  //       file_id: [],
  //       note_id: []
  //     };

  //     elementsToSend[type] = elements;

  //     await this.api.delete({
  //       url: `/api/v0.0.2/deals/${dealId}/shares`,
  //       data: [
  //         {
  //           user_id: shareId,
  //           ...elementsToSend
  //         }
  //       ]
  //     });
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  public createShareAction = async (data: ICreateShareData): Promise<void> => {
    try {
      const { dealId, emails, roleId, message, share } = data;
      await this.api.post({
        url: `/api/v0.0.3/deals/${dealId}/share-data`,
        data: {
          emails,
          message,
          deal_id: share.deal_id,
          role_id: roleId,
          components: share?.deal_id?.length ? [] : share.components
        }
      });
      toastify({ message: `Invitation to collaborate was sent via email to <b> ${emails.join(" , ")}</b>` });
    } catch (error: any) {
      const arrayOfEmailErrors = Object.values(parseLaravelErrors(error.errors, "email")).flat(10);
      toastify({ message: arrayOfEmailErrors.join(".<br/>"), type: "error" });
      throw error;
    }
  };

  public resendInviteAction = async (inviteId: number): Promise<void> => {
    try {
      await this.api.post({
        url: `/api/v0.0.2/invites/${inviteId}/resend`
      });
    } catch (error) {
      throw error;
    }
  };

  public setReachOutManageAction = (data: IReachOutManage | null) => {
    this.dispatch({ type: DealAction.SetReachOutManage, payload: data });
  };

  public postReachOutAction = async ({ dealId, ...data }: PostReachOutReq): Promise<PostReachOutRes> => {
    const res: AxiosResponse<AltiusRes<PostReachOutRes>> = await this.api.post({
      url: `/api/v0.0.3/deals/${dealId}/reach-out-email`,
      data
    });
    return res.data.data;
  };

  public getEmptyShareTreeAction = async (dealId: number): Promise<any> => {
    const res: AxiosResponse<AltiusRes<any>> = await this.api.get({
      url: `/api/v0.0.3/deals/${dealId}/share-data/empty-tree`
    });
    return res.data.data;
  };
}
